// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlogPaginate_wrapper__M5elK","link":"BlogPaginate_link___281_","current":"BlogPaginate_current__XZklt"};